import React, { useEffect, useMemo, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import Lottie from 'react-lottie';
import { Container, Menu } from './styles';

import logo from '~/assets/logos/logo-menu.svg';
import avatar from '~/assets/logos/avatar.png';

import logout from '~/assets/animations/logout.json';
import { useAuth } from '~/hooks/Auth';

const Header: React.FC = () => {
  const logoutRef = useRef<HTMLDivElement>(null);
  const { user, signOut } = useAuth();
  const location = useLocation();
  const [active, setActive] = useState(false);
  const [showBtnLogout, setShowBtnLogout] = useState(false);

  const name = useMemo(() => {
    return user.name.split(' ')[0];
  }, [user.name]);

  const firstLetter = useMemo(() => {
    return name.charAt(0).toUpperCase();
  }, [name]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        logoutRef.current &&
        !logoutRef.current.contains(event.target as Node)
      ) {
        setShowBtnLogout(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setActive(false);
  }, [location]);

  return (
    <>
      <Container>
        <div
          id="menu"
          className="container-fluid py-3 menu-fix d-lg-flex align-items-center"
        >
          <div className="row w-lg-100">
            <div className="col-12">
              <div className="container px-0 px-lg-3">
                <div className="row">
                  <div className="col-12 d-flex justify-content-between align-items-center text-center">
                    <div>
                      <div className="d-flex align-items-center">
                        <img
                          src={logo}
                          width={60}
                          height={40}
                          alt="logo"
                          className="logo"
                        />
                        <span className="name mb-0 ms-2">Hi, {name}!</span>
                      </div>
                    </div>
                    <Menu>
                      <div className="d-none d-lg-block menu-group active">
                        <div className="menu d-flex flex-column flex-lg-row justify-content-center">
                          <NavLink
                            to={`${process.env.PUBLIC_URL}/dashboard`}
                            className="btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center"
                            exact
                            activeClassName="active"
                          >
                            Dashboard
                          </NavLink>
                          <NavLink
                            to={`${process.env.PUBLIC_URL}/lenders`}
                            className="btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center"
                            exact
                            activeClassName="active"
                          >
                            Lenders
                          </NavLink>
                        </div>
                      </div>
                    </Menu>
                    <Menu active={active}>
                      <button
                        type="button"
                        className="nav-btn bg-transparent d-lg-none border-0 mx-3"
                        onClick={() => setActive(!active)}
                      >
                        <span />
                        <span />
                        <span />
                      </button>
                      <div className="d-lg-none menu-group active">
                        <div className="menu d-flex flex-column flex-lg-row justify-content-center">
                          <NavLink
                            to={`${process.env.PUBLIC_URL}/dashboard`}
                            className="btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center"
                            exact
                            activeClassName="active"
                          >
                            Dashboard
                          </NavLink>
                          <NavLink
                            to={`${process.env.PUBLIC_URL}/lenders`}
                            className="btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center"
                            exact
                            activeClassName="active"
                          >
                            Lenders
                          </NavLink>

                          <div>
                            <button
                              type="button"
                              className="border-0 logout mt-5 position-inherit"
                              onClick={() => signOut()}
                            >
                              <span className="d-flex align-items-center anim-lottie pe-none">
                                <Lottie
                                  options={{
                                    animationData: logout,
                                    autoplay: true,
                                    loop: true,
                                    rendererSettings: {
                                      preserveAspectRatio: 'xMidYMid slice',
                                    },
                                  }}
                                  height={50}
                                  width={50}
                                />
                                <span className="ms-2">Logout</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        className="d-none d-lg-block position-relative width-200 text-end"
                        ref={logoutRef}
                      >
                        <button
                          type="button"
                          className="position-relative border-0 bg-transparent"
                          onClick={() => setShowBtnLogout(!showBtnLogout)}
                        >
                          <img
                            src={avatar}
                            width={40}
                            height={40}
                            alt="Logout"
                          />
                          <span className="first-letter">{firstLetter}</span>
                        </button>
                        {showBtnLogout && (
                          <button
                            type="button"
                            className="border-0 logout position-absolute"
                            onClick={() => signOut()}
                          >
                            <span className="d-flex align-items-center anim-lottie pe-none">
                              <Lottie
                                options={{
                                  animationData: logout,
                                  autoplay: true,
                                  loop: true,
                                  rendererSettings: {
                                    preserveAspectRatio: 'xMidYMid slice',
                                  },
                                }}
                                height={50}
                                width={50}
                              />
                              <span className="ms-2">Logout</span>
                            </span>
                          </button>
                        )}
                      </div>
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Header;
